/**
 * @generated SignedSource<<a54f7e92b98ec38ed3d6d9dcb547ae36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AssistantMode = "aiStory" | "assistant" | "cardDetail" | "letsPractise" | "listenVocab" | "speaking" | "%future added value";
export type chatIdeasMutation$variables = {
  chatId?: string | null;
  deckId: string;
  mode: AssistantMode;
  question?: string | null;
  withTranslation?: boolean | null;
};
export type chatIdeasMutation$data = {
  readonly generateChatIdeas: ReadonlyArray<{
    readonly idea: string;
    readonly ideaTranslation: string | null;
    readonly tags: ReadonlyArray<string | null> | null;
  }>;
};
export type chatIdeasMutation = {
  response: chatIdeasMutation$data;
  variables: chatIdeasMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chatId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "deckId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mode"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "question"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "withTranslation"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "chatId",
        "variableName": "chatId"
      },
      {
        "kind": "Variable",
        "name": "deckId",
        "variableName": "deckId"
      },
      {
        "kind": "Variable",
        "name": "mode",
        "variableName": "mode"
      },
      {
        "kind": "Variable",
        "name": "question",
        "variableName": "question"
      },
      {
        "kind": "Variable",
        "name": "withTranslation",
        "variableName": "withTranslation"
      }
    ],
    "concreteType": "ChatIdea",
    "kind": "LinkedField",
    "name": "generateChatIdeas",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "idea",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ideaTranslation",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tags",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "chatIdeasMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "chatIdeasMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "a634962a793ab6cebd2784c44f66ba65",
    "id": null,
    "metadata": {},
    "name": "chatIdeasMutation",
    "operationKind": "mutation",
    "text": "mutation chatIdeasMutation(\n  $chatId: String\n  $question: String\n  $deckId: String!\n  $mode: AssistantMode!\n  $withTranslation: Boolean\n) {\n  generateChatIdeas(chatId: $chatId, question: $question, deckId: $deckId, mode: $mode, withTranslation: $withTranslation) {\n    idea\n    ideaTranslation\n    tags\n  }\n}\n"
  }
};
})();

(node as any).hash = "dfc2784c0892c6f456b9f4a7f2f67cbf";

export default node;
